import { Directive, effect, inject, Injector, TemplateRef, ViewContainerRef } from '@angular/core';
import { ViewportService } from "@core/services/viewport.service";

@Directive({
  selector: '[isNotMobile]',
  standalone: true,
})
export class IsNotMobileDirective {
  #templateRef = inject(TemplateRef<unknown>);
  #viewContainer = inject(ViewContainerRef);
  #viewportService = inject(ViewportService);
  #injector = inject(Injector);

  constructor() {
    effect(() => {
      const isMobile = this.#viewportService.isMobile();
      this.#updateView(isMobile);
    }, {injector: this.#injector});
  }

  #updateView(isMobile: boolean): void {
    this.#viewContainer.clear();
    if (!isMobile) {
      this.#viewContainer.createEmbeddedView(this.#templateRef);
    }
  }
}
